module.exports = __webpack_public_path__ + "img/works_subway_mobile_app_2.62774235.png";